<template>
  <div class="GoTop">
    <div class="ScrollTop" @click="goTop()">
      <img src="../../public/img/top.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'GoTop',
  props: {

  },
  methods:{
    goTop(){
      $(".homeBox").animate({scrollTop:"0"},300)
    }
  },
  mounted(){

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

</style>
